import React from 'react'
import {BsLinkedin} from 'react-icons/bs'
import {FaGithub} from 'react-icons/fa'
// import {TbBrandFiverr} from 'react-icons/tb'

const HeaderSocials = () => {
  return (
    <div className='header__socials'>
        <a href="https://www.linkedin.com/in/partham-chawla-a8494021a/" target='_blank' rel="noreferrer"><BsLinkedin/></a>
        <a href="https://github.com/ParthamKumar" target='_blank' rel="noreferrer"><FaGithub /></a>
        {/* <a href="https://www.fiverr.com/parthamchawla?up_rollout=true" target='_blank' rel="noreferrer"><TbBrandFiverr /></a>   */}
    </div>
  )
}

export default HeaderSocials
